import { useEffect } from "react"

import { analyticsTrackEvent } from "@utils/analytics"

interface RecipeAnalyticsProps {
  recipeName: Domain.Recipe.DataTransferObjects.RecipeData["name"]
  recipeId: Domain.Recipe.DataTransferObjects.RecipeData["id"]
  author: Domain.Recipe.DataTransferObjects.RecipeData["author"]
}

const RecipeAnalytics = (props: RecipeAnalyticsProps): null => {
  const { recipeName, recipeId, author } = props

  useEffect(() => {
    if (recipeName) {
      // facebook event #1: recipe view
      analyticsTrackEvent("view_content", {
        facebookEvent: "ViewContent",
        action: "view_recipe",
        contents: [{ type: "recipe", name: recipeName, id: recipeId }],
        authorName: author?.user_name ?? undefined,
      })
      const timer60 = setTimeout(() => {
        analyticsTrackEvent("view_content", {
          action: "timer_60",
          contents: [{ type: "recipe", name: recipeName, id: recipeId }],
        })
      }, 60000)
      const timer120 = setTimeout(() => {
        analyticsTrackEvent("view_content", {
          action: "timer_120",
          contents: [{ type: "recipe", name: recipeName, id: recipeId }],
        })
      }, 120000)
      return () => {
        clearTimeout(timer60)
        clearTimeout(timer120)
      }
    }
  })

  return null
}

export default RecipeAnalytics
